import classNames from 'classnames';
import React__default, { Component } from 'react';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import { BUTTON_SIZE, FOOTER_BUTTON_ALIGNMENT } from '../consts.js';
import ActionButtons from './ActionButtons.js';
import 'wix-rich-content-common';
import './Button.js';

var css_248z = ".J2k9A{align-items:center;box-sizing:border-box;display:inline-flex;flex-direction:row;font-size:14px;height:88px;justify-content:flex-end;max-width:420px;width:100%}[dir] .J2k9A{background:#fff;border-top:1px solid var(--ricos-settings-dividers-color,#ededed);padding:24px}.J2k9A.kssM4{height:max-content;justify-content:center;max-width:100%}[dir] .J2k9A.kssM4{border-top:none;padding:0}.J2k9A.kssM4.wrkDT{justify-content:flex-end}@supports not (contain:inline-size){@media only screen and (max-width:640px){.J2k9A.kssM4{grid-row-gap:9px;display:grid;grid-auto-columns:100%;grid-template-areas:\"save\" \"cancel\"}}}@container (width < 640px){.J2k9A.kssM4{grid-row-gap:9px;display:grid;grid-auto-columns:100%;grid-template-areas:\"save\" \"cancel\"}}.eC5Eb{align-items:center;bottom:0;display:inline-flex;flex-direction:row;position:fixed;z-index:5}.BQnP8{width:276px}";
var styles = {"settingsPanel_footer":"J2k9A","modal":"kssM4","flexEndModalButtons":"wrkDT","settingsPanel_footer_fixed":"eC5Eb","settingsPanel_footer_buttons_wrapper":"BQnP8"};
styleInject(css_248z);

class SettingsPanelFooter extends Component {
  render() {
    const {
      save,
      cancel,
      cancelLabel,
      saveLabel,
      fixed,
      className,
      t,
      layoutOptions,
      selected = true,
      buttonSize = BUTTON_SIZE.small
    } = this.props;
    const { isModal, buttonAlignment = FOOTER_BUTTON_ALIGNMENT.CENTER } = layoutOptions;
    const endAlignment = buttonAlignment === FOOTER_BUTTON_ALIGNMENT.END;
    const saveText = saveLabel || t("SettingsPanelFooter_Save");
    const cancelText = cancelLabel || t("SettingsPanelFooter_Cancel");
    return /* @__PURE__ */ React__default.createElement(
      "div",
      {
        className: classNames(
          styles.settingsPanel_footer,
          className,
          isModal && styles.modal,
          endAlignment && styles.flexEndModalButtons,
          {
            [styles.settingsPanel_footer_fixed]: fixed || false
          }
        )
      },
      /* @__PURE__ */ React__default.createElement(
        "div",
        {
          className: classNames(
            styles.settingsPanel_footer_buttons_wrapper,
            isModal && styles.modal
          )
        },
        /* @__PURE__ */ React__default.createElement(
          ActionButtons,
          {
            size: buttonSize,
            onCancel: cancel,
            onSave: save,
            cancelText,
            saveText,
            disableSave: !selected,
            t
          }
        )
      )
    );
  }
}
SettingsPanelFooter.defaultProps = {
  layoutOptions: {}
};
var SettingsPanelFooter$1 = SettingsPanelFooter;

export { SettingsPanelFooter$1 as default };
//# sourceMappingURL=SettingsPanelFooter.js.map
